export const ANALYTICS_EVENT_TYPES = [
  'filters_applied',
  'apartment_viewed',
  'apartment_clicked',
  'chat_search'
] as const

export type AnalyticsEventType = (typeof ANALYTICS_EVENT_TYPES)[number]

export const EVENTS_TABLE_PAGE_SIZE = 25

export const TOP_APARTMENTS_FETCH_LIMIT = 200
